import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Organization } from "../../../types/organization";

interface OrgState {
  currentOrganization: Organization | null;

}

const initialState: OrgState = {
  currentOrganization: null,
 
};


const orgSlice = createSlice({
  name: "organization",
  initialState,
  reducers: {
    setOrganization(state, action: PayloadAction<Organization>) {
      state.currentOrganization = action.payload;
    },
    clearOrganization(state) {
      state.currentOrganization = null;
    },
    
  },
});

export const { setOrganization, clearOrganization } = orgSlice.actions;
export default orgSlice.reducer;
